<template>
  <div class="row">
    <div class="col-xs-12 text-lg">
      <label>{{ title }}</label>
      <span v-if="type === 'single'">
        {{ description }}
      </span>
      <ul id="eixos" v-if="type === 'list'">
        <li v-for="item in list" :key="item.codigo">
          {{ item.descricao }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    list: {
      type: Array
    },
    description: {
      type: String
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dados/InfoDados.vue